module.exports = __webpack_public_path__ + "static/media/ListViewIOnIcon.cecd5768.svg";